import type { IdentityClaims } from "@istari-frontend/auth";
import { useEffect } from "react";

import { useIsUserGrantCustomerAdmin } from "~/external-api/admin";
import { useMyMemberships } from "~/external-api/profile";
import { checkIsOrgOwner, hasCustomerAdminGrant } from "~/permissions";

import type { Session } from "../model/session";

// Legacy tokens carry no role claims, so this mirrors the registry: organization owner plus the customer_admin grant.
export function useLegacySession(
  mode: "zitadel-direct" | "identity-v1",
  claims: IdentityClaims,
  upstreamUserId: string | undefined,
): Session {
  const memberships = useMyMemberships();
  const isOrgOwner = checkIsOrgOwner(memberships.data);
  const grants = useIsUserGrantCustomerAdmin({ userId: isOrgOwner ? upstreamUserId : undefined });
  const isAdmin = isOrgOwner && hasCustomerAdminGrant(grants.data);
  useEffect(() => {
    if (isOrgOwner && grants.isError) {
      console.error("[session] customer_admin grant check failed; administrator screens hidden", grants.error);
    }
  }, [isOrgOwner, grants.isError, grants.error]);
  return {
    mode,
    isLoading: memberships.isLoading || (isOrgOwner && grants.isLoading),
    tenantId: claims.zitadelOrganizationId,
    upstreamUserId,
    upstreamTenantId: claims.zitadelOrganizationId,
    platformRoles: [],
    tenantRoles: [],
    isPlatformAdmin: isAdmin,
    isTenantAdminOf: () => isAdmin,
    administeredTenants: isAdmin ? { all: true } : { all: false, tenantIds: [] },
  };
}
